export const ManageMySiteTestIDs = {
  footer: {
    container: 'sticky-action-footer',
    cancel: 'sticky-footer-cancel-button',
    save: 'sticky-footer-save-button',
    savingIndicator: 'sticky-footer-saving-indicator',
  },
  stateDropdown: {
    trigger: 'manage-my-site-state-dropdown',
    option: (value: string) => `manage-my-site-state-option-${value}`,
    error: 'manage-my-site-state-dropdown-error',
    errorText: 'manage-my-site-state-dropdown-error-text',
  },
  bottomSheet: {
    backdrop: 'bottom-sheet-backdrop',
    card: 'bottom-sheet-card',
    closeButtonContainer: 'bottom-sheet-close-button-container',
    closeButton: 'bottom-sheet-close-button',
    title: 'bottom-sheet-title',
    titleText: 'bottom-sheet-title-text',
    clearAll: 'bottom-sheet-clear-all-button',
    save: 'bottom-sheet-save-button',
  },
  fieldGroup: {
    label: (text: string) => `field-group-label-${text}`,
    labelText: (text: string) => `field-group-label-text-${text}`,
    valueText: (text: string) => `field-group-value-text-${text}`,
    value: (text: string) => `field-group-value-${text}`,
  },
  fieldWrapper: {
    wrapper: (id: string) => `${id}-wrapper`,
  },
  phoneInput: {
    inputContainer: 'phone-input-container',
    input: 'phone-input',
    delete: 'delete-phone-button',
    error: 'phone-error-message',
  },
  sectionTitle: {
    heading: (text: string) => `section-heading-${text}`,
    headingText: (text: string) => `section-heading-text-${text}`,
  },
  aboutSection: {
    container: 'about-section',
    subLabel: 'about-section-sub-label',
    subLabelText: 'about-section-sub-label-text',
    input: 'about-section-notes-input',
    charCount: 'about-char-count',
    error: 'about-error-message',
    warning: 'about-warning-message',
    errorIcon: 'about-section-error-icon',
    errorText: 'about-section-error-text',
    warningIcon: 'about-section-warning-icon',
    warningText: 'about-section-warning-text',
  },
  addressSection: {
    container: 'address-section',
    countryField: 'country-field',
    countryLabel: 'country-label',
    countryInput: 'country-input',
    countryDropdown: 'country-dropdown',
    streetField: 'street-field',
    streetLabel: 'street-label',
    streetInput: 'street-input',
    cityField: 'city-field',
    cityLabel: 'city-label',
    cityInput: 'city-input',
    stateField: 'state-field',
    stateLabel: 'state-label',
    stateDropdown: 'state-dropdown',
    stateError: 'state-error-message',
    zipField: 'zip-field',
    zipLabel: 'zip-label',
    zipInput: 'zip-input',
    zipError: 'zip-error-message',
  },
  avatarSection: {
    container: 'avatar-section',
    image: 'avatar-image',
    hint: 'avatar-hint',
    hintText: 'avatar-hint-text',
    confirmRow: 'avatar-confirm-row',
    confirmButton: 'avatar-confirm-button',
    cancelButton: 'avatar-cancel-button',
    changePhotoButton: 'change-photo-button',
    changePhotoText: 'change-photo-button-text',
    errorContainer: 'avatar-error-container',
    retryButton: 'avatar-retry-button',
  },
  contactSection: {
    container: 'contact-section',
    nameField: 'display-name-field',
    nameLabel: 'display-name-label',
    nameInput: 'display-name-input',
    nameError: 'name-error-message',
    emailField: 'email-field',
    emailLabel: 'email-label',
    emailInput: 'email-input',
    emailError: 'email-error-message',
    primaryPhoneField: 'primary-phone-field',
    primaryPhoneLabel: 'primary-phone-label',
    primaryPhoneInput: 'primary-phone-input',
    secondaryPhoneField: 'secondary-phone-field',
    secondaryPhoneLabel: 'secondary-phone-label',
    secondaryPhoneInput: 'secondary-phone-input',
    addSecondaryButton: 'add-secondary-phone-button',
  },
  photosSection: {
    section: 'photos-section',
    sectionTitle: 'photos-section-title',
    sectionTitleText: 'transformation-photos-text',
    grid: 'photos-grid',
    card: (type: 'before' | 'after') => `${type}-photo-card`,
    label: (type: 'before' | 'after') => `${type}-photo-label`,
    imageWrapper: (type: 'before' | 'after') => `${type}-image-wrapper`,
    transformationPhoto: (type: 'before' | 'after') =>
      `${type}-transformation-photo`,
    photoImage: (type: 'before' | 'after') => `${type}-photo-image`,
    uploadButton: (type: 'before' | 'after') => `${type}-upload-button`,
    uploadIcon: (type: 'before' | 'after') => `${type}-upload-icon`,
    uploadText: (type: 'before' | 'after') => `${type}-upload-text`,
    uploadSubtext: (type: 'before' | 'after') => `${type}-upload-subtext`,
    uploadSizeText: (type: 'before' | 'after') => `${type}-upload-size-text`,
    uploadLoader: (type: 'before' | 'after') => `${type}-upload-loader`,
    actionRow: (type: 'before' | 'after') => `${type}-action-row`,
    confirmButton: (type: 'before' | 'after') => `${type}-confirm-button`,
    confirmText: (type: 'before' | 'after') => `${type}-confirm-text`,
    cancelButton: (type: 'before' | 'after') => `${type}-cancel-button`,
    cancelText: (type: 'before' | 'after') => `${type}-cancel-text`,
    uploadingStatus: (type: 'before' | 'after') => `${type}-uploading-status`,
    uploadingText: (type: 'before' | 'after') => `${type}-uploading-text`,
    replaceButton: (type: 'before' | 'after') => `${type}-replace-button`,
    replaceText: (type: 'before' | 'after') => `${type}-replace-text`,
    retryButton: (type: 'before' | 'after') => `${type}-retry-button`,
    retryText: (type: 'before' | 'after') => `${type}-retry-text`,
    retryCancelButton: (type: 'before' | 'after') =>
      `${type}-retry-cancel-button`,
  },
  websiteSection: {
    container: 'website-section',
    input: 'website-input',
    error: 'website-error-message',
    shareLinkContainer: 'share-link-text-container',
    shareLinkLabel: 'share-link-text',
    shareLinkUrl: 'share-link-url',
    shareLinkUrlText: 'share-link-url-text',
    copyButton: 'copy-final-share-link-button',
    copyIcon: 'copy-final-share-link-icon',
    inputWrapper: 'website-section-input-wrapper',
  },
  loader: 'manage-my-site-error-loader',
  errorText: 'manage-my-site-error-text',
};

export default ManageMySiteTestIDs;
